export function distinct<T>(array: Array<T>, keySelector?: (item: T) => any): Array<T> {
  let values: Array<any> = array.map(item => keySelector ? keySelector(item) : item);

  return Array.from(new Set(values)).map(
    key => keySelector
      ? array.find(item => keySelector(item) === key)
      : key
  );
}